module.exports = __webpack_public_path__ + "static/img/result_main_banner.1f83a203.png";